var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasket4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60,19.5h-7.599L46.573,5.659C46.021,4.348,44.745,3.5,43.321,3.5h-1.463c-0.447-1.72-2-3-3.858-3H22 c-1.858,0-3.411,1.28-3.858,3h-1.463c-1.423,0-2.7,0.848-3.252,2.159L7.599,19.5H0v8h2v27.434C2,57.451,4.048,59.5,6.566,59.5 h46.867c2.518,0,4.566-2.049,4.566-4.566V27.5h2V19.5z M22,2.5h16c1.103,0,2,0.897,2,2s-0.897,2-2,2H22c-1.103,0-2-0.897-2-2 S20.897,2.5,22,2.5z M15.271,6.435C15.509,5.867,16.062,5.5,16.679,5.5h1.463c0.447,1.72,2,3,3.858,3h16 c1.858,0,3.411-1.28,3.858-3h1.463c0.617,0,1.169,0.367,1.408,0.935L50.231,19.5H9.769L15.271,6.435z M56,54.934 c0,0.924-0.495,1.729-1.23,2.181C54.906,56.943,55,56.736,55,56.5c0-0.552-0.448-1-1-1s-1,0.448-1,1 c0,0.485,0.352,0.871,0.811,0.962c-0.124,0.019-0.248,0.038-0.377,0.038H48h-6h-6h-6h-6h-6h-6H6.566 c-0.129,0-0.253-0.02-0.377-0.038C6.648,57.371,7,56.985,7,56.5c0-0.552-0.448-1-1-1s-1,0.448-1,1c0,0.236,0.094,0.443,0.23,0.614 C4.495,56.662,4,55.858,4,54.934V27.5h52V54.934z M58,25.5H2v-4h4.757l-0.679,1.612c-0.214,0.509,0.025,1.095,0.534,1.31 C6.739,24.475,6.87,24.5,7,24.5c0.39,0,0.761-0.229,0.922-0.612L8.927,21.5h42.146l1.005,2.388C52.239,24.271,52.61,24.5,53,24.5 c0.129,0,0.261-0.025,0.388-0.078c0.509-0.215,0.748-0.801,0.534-1.31L53.243,21.5H58V25.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 32.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 29.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 35.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 32.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 32.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 29.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 35.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 32.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 32.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 29.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 29.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 35.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 35.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 32.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 32.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 29.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 35.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 29.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 35.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 32.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 32.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 38.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 38.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 38.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 38.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 38.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 38.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 38.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 38.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 38.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 29.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 29.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 35.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 35.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 44.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 41.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 47.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 44.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 44.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 41.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 47.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 44.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 44.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 41.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 41.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 47.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 47.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 44.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 44.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 41.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 47.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 41.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 47.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 44.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 44.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 50.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 50.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 50.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 50.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 50.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 50.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 50.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 50.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 41.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 41.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 47.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 47.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 56.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 53.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 56.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 56.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 53.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 56.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 53.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 53.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 56.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 53.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 53.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 56.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 56.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 53.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 53.5,
    r: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket4);
export default __webpack_public_path__ + "static/media/basket4.f443f770f6d9332936e83d3d39636936.svg";
export { ForwardRef as ReactComponent };